export function passValidation(value, validators, formState) {
  if (validators === void 0) {
    validators = [];
  }

  var checks = validators.map(function (fn) {
    return fn(value, formState);
  });
  var isValid = checks.every(function (val) {
    return val === undefined || val === null;
  });
  return {
    checks: checks,
    isValid: isValid
  };
}